//# sourceMappingURL=data_source.mjs.map
/// <reference types="./data_source.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $calendar from "../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $mime_types from "../../mime_types/mime_types.mjs";
import * as $user_id from "../data/auth/user_id.mjs";
import * as $connector from "../data/connector.mjs";
import * as $question from "../data/proposal_element/question.mjs";
import * as $tag from "../data/tag.mjs";
import * as $decrypt from "../decrypt.mjs";
import { toList, CustomType as $CustomType, isEqual } from "../gleam.mjs";

export class Pending extends $CustomType {}
export const Status$Pending = () => new Pending();
export const Status$isPending = (value) => value instanceof Pending;

export class Verified extends $CustomType {}
export const Status$Verified = () => new Verified();
export const Status$isVerified = (value) => value instanceof Verified;

export class NotVerified extends $CustomType {}
export const Status$NotVerified = () => new NotVerified();
export const Status$isNotVerified = (value) => value instanceof NotVerified;

export class Archived extends $CustomType {}
export const Status$Archived = () => new Archived();
export const Status$isArchived = (value) => value instanceof Archived;

export class Outdated extends $CustomType {}
export const Status$Outdated = () => new Outdated();
export const Status$isOutdated = (value) => value instanceof Outdated;

export class Processing extends $CustomType {}
export const Status$Processing = () => new Processing();
export const Status$isProcessing = (value) => value instanceof Processing;

export class Failed extends $CustomType {}
export const Status$Failed = () => new Failed();
export const Status$isFailed = (value) => value instanceof Failed;

export class StatusStats extends $CustomType {
  constructor(verified, pending, not_verified, outdated) {
    super();
    this.verified = verified;
    this.pending = pending;
    this.not_verified = not_verified;
    this.outdated = outdated;
  }
}
export const StatusStats$StatusStats = (verified, pending, not_verified, outdated) =>
  new StatusStats(verified, pending, not_verified, outdated);
export const StatusStats$isStatusStats = (value) =>
  value instanceof StatusStats;
export const StatusStats$StatusStats$verified = (value) => value.verified;
export const StatusStats$StatusStats$0 = (value) => value.verified;
export const StatusStats$StatusStats$pending = (value) => value.pending;
export const StatusStats$StatusStats$1 = (value) => value.pending;
export const StatusStats$StatusStats$not_verified = (value) =>
  value.not_verified;
export const StatusStats$StatusStats$2 = (value) => value.not_verified;
export const StatusStats$StatusStats$outdated = (value) => value.outdated;
export const StatusStats$StatusStats$3 = (value) => value.outdated;

export class SheetLabels extends $CustomType {
  constructor(sheet_index, sheet_title, kind, question_column_index, answer_column_index, rows_to_process) {
    super();
    this.sheet_index = sheet_index;
    this.sheet_title = sheet_title;
    this.kind = kind;
    this.question_column_index = question_column_index;
    this.answer_column_index = answer_column_index;
    this.rows_to_process = rows_to_process;
  }
}
export const SheetLabels$SheetLabels = (sheet_index, sheet_title, kind, question_column_index, answer_column_index, rows_to_process) =>
  new SheetLabels(sheet_index,
  sheet_title,
  kind,
  question_column_index,
  answer_column_index,
  rows_to_process);
export const SheetLabels$isSheetLabels = (value) =>
  value instanceof SheetLabels;
export const SheetLabels$SheetLabels$sheet_index = (value) => value.sheet_index;
export const SheetLabels$SheetLabels$0 = (value) => value.sheet_index;
export const SheetLabels$SheetLabels$sheet_title = (value) => value.sheet_title;
export const SheetLabels$SheetLabels$1 = (value) => value.sheet_title;
export const SheetLabels$SheetLabels$kind = (value) => value.kind;
export const SheetLabels$SheetLabels$2 = (value) => value.kind;
export const SheetLabels$SheetLabels$question_column_index = (value) =>
  value.question_column_index;
export const SheetLabels$SheetLabels$3 = (value) => value.question_column_index;
export const SheetLabels$SheetLabels$answer_column_index = (value) =>
  value.answer_column_index;
export const SheetLabels$SheetLabels$4 = (value) => value.answer_column_index;
export const SheetLabels$SheetLabels$rows_to_process = (value) =>
  value.rows_to_process;
export const SheetLabels$SheetLabels$5 = (value) => value.rows_to_process;

export class Qna extends $CustomType {
  constructor(question, answer) {
    super();
    this.question = question;
    this.answer = answer;
  }
}
export const Qna$Qna = (question, answer) => new Qna(question, answer);
export const Qna$isQna = (value) => value instanceof Qna;
export const Qna$Qna$question = (value) => value.question;
export const Qna$Qna$0 = (value) => value.question;
export const Qna$Qna$answer = (value) => value.answer;
export const Qna$Qna$1 = (value) => value.answer;

export class Display extends $CustomType {
  constructor(name, language, mime_type, origin, qna, breadcrumbs) {
    super();
    this.name = name;
    this.language = language;
    this.mime_type = mime_type;
    this.origin = origin;
    this.qna = qna;
    this.breadcrumbs = breadcrumbs;
  }
}
export const Display$Display = (name, language, mime_type, origin, qna, breadcrumbs) =>
  new Display(name, language, mime_type, origin, qna, breadcrumbs);
export const Display$isDisplay = (value) => value instanceof Display;
export const Display$Display$name = (value) => value.name;
export const Display$Display$0 = (value) => value.name;
export const Display$Display$language = (value) => value.language;
export const Display$Display$1 = (value) => value.language;
export const Display$Display$mime_type = (value) => value.mime_type;
export const Display$Display$2 = (value) => value.mime_type;
export const Display$Display$origin = (value) => value.origin;
export const Display$Display$3 = (value) => value.origin;
export const Display$Display$qna = (value) => value.qna;
export const Display$Display$4 = (value) => value.qna;
export const Display$Display$breadcrumbs = (value) => value.breadcrumbs;
export const Display$Display$5 = (value) => value.breadcrumbs;

export class DataSource extends $CustomType {
  constructor(id, status, display, kind, authors, owner, document_id, blob_link, content_link, hash, version, tags, org_id, expiration_date) {
    super();
    this.id = id;
    this.status = status;
    this.display = display;
    this.kind = kind;
    this.authors = authors;
    this.owner = owner;
    this.document_id = document_id;
    this.blob_link = blob_link;
    this.content_link = content_link;
    this.hash = hash;
    this.version = version;
    this.tags = tags;
    this.org_id = org_id;
    this.expiration_date = expiration_date;
  }
}
export const DataSource$DataSource = (id, status, display, kind, authors, owner, document_id, blob_link, content_link, hash, version, tags, org_id, expiration_date) =>
  new DataSource(id,
  status,
  display,
  kind,
  authors,
  owner,
  document_id,
  blob_link,
  content_link,
  hash,
  version,
  tags,
  org_id,
  expiration_date);
export const DataSource$isDataSource = (value) => value instanceof DataSource;
export const DataSource$DataSource$id = (value) => value.id;
export const DataSource$DataSource$0 = (value) => value.id;
export const DataSource$DataSource$status = (value) => value.status;
export const DataSource$DataSource$1 = (value) => value.status;
export const DataSource$DataSource$display = (value) => value.display;
export const DataSource$DataSource$2 = (value) => value.display;
export const DataSource$DataSource$kind = (value) => value.kind;
export const DataSource$DataSource$3 = (value) => value.kind;
export const DataSource$DataSource$authors = (value) => value.authors;
export const DataSource$DataSource$4 = (value) => value.authors;
export const DataSource$DataSource$owner = (value) => value.owner;
export const DataSource$DataSource$5 = (value) => value.owner;
export const DataSource$DataSource$document_id = (value) => value.document_id;
export const DataSource$DataSource$6 = (value) => value.document_id;
export const DataSource$DataSource$blob_link = (value) => value.blob_link;
export const DataSource$DataSource$7 = (value) => value.blob_link;
export const DataSource$DataSource$content_link = (value) => value.content_link;
export const DataSource$DataSource$8 = (value) => value.content_link;
export const DataSource$DataSource$hash = (value) => value.hash;
export const DataSource$DataSource$9 = (value) => value.hash;
export const DataSource$DataSource$version = (value) => value.version;
export const DataSource$DataSource$10 = (value) => value.version;
export const DataSource$DataSource$tags = (value) => value.tags;
export const DataSource$DataSource$11 = (value) => value.tags;
export const DataSource$DataSource$org_id = (value) => value.org_id;
export const DataSource$DataSource$12 = (value) => value.org_id;
export const DataSource$DataSource$expiration_date = (value) =>
  value.expiration_date;
export const DataSource$DataSource$13 = (value) => value.expiration_date;

export class SourceFilters extends $CustomType {
  constructor(included_tags, excluded_tags, excluded_kinds) {
    super();
    this.included_tags = included_tags;
    this.excluded_tags = excluded_tags;
    this.excluded_kinds = excluded_kinds;
  }
}
export const SourceFilters$SourceFilters = (included_tags, excluded_tags, excluded_kinds) =>
  new SourceFilters(included_tags, excluded_tags, excluded_kinds);
export const SourceFilters$isSourceFilters = (value) =>
  value instanceof SourceFilters;
export const SourceFilters$SourceFilters$included_tags = (value) =>
  value.included_tags;
export const SourceFilters$SourceFilters$0 = (value) => value.included_tags;
export const SourceFilters$SourceFilters$excluded_tags = (value) =>
  value.excluded_tags;
export const SourceFilters$SourceFilters$1 = (value) => value.excluded_tags;
export const SourceFilters$SourceFilters$excluded_kinds = (value) =>
  value.excluded_kinds;
export const SourceFilters$SourceFilters$2 = (value) => value.excluded_kinds;

export const file_max_upload_size = 75_000_000;

export function create_status_stats(count_status) {
  let _block;
  let _pipe = count_status;
  _block = $dict.from_list(_pipe);
  let statuses = _block;
  return new StatusStats(
    (() => {
      let _pipe$1 = statuses;
      let _pipe$2 = $dict.get(_pipe$1, new Verified());
      return $result.unwrap(_pipe$2, 0);
    })(),
    (() => {
      let _pipe$1 = statuses;
      let _pipe$2 = $dict.get(_pipe$1, new Pending());
      return $result.unwrap(_pipe$2, 0);
    })(),
    (() => {
      let _pipe$1 = statuses;
      let _pipe$2 = $dict.get(_pipe$1, new NotVerified());
      return $result.unwrap(_pipe$2, 0);
    })(),
    (() => {
      let _pipe$1 = statuses;
      let _pipe$2 = $dict.get(_pipe$1, new Outdated());
      return $result.unwrap(_pipe$2, 0);
    })(),
  );
}

function encode_display(display) {
  return $json.object(
    toList([
      ["name", $json.string(display.name)],
      ["language", $json.nullable(display.language, $json.string)],
      ["mime_type", $json.string($mime_types.to_string(display.mime_type))],
      ["origin", $json.nullable(display.origin, $json.string)],
      [
        "qna",
        $json.nullable(
          display.qna,
          (qna) => {
            return $json.object(
              toList([
                ["question", $json.string(qna.question)],
                ["answer", $json.string(qna.answer)],
              ]),
            );
          },
        ),
      ],
      ["breadcrumbs", $json.array(display.breadcrumbs, $json.string)],
    ]),
  );
}

export function status_to_string(status) {
  if (status instanceof Pending) {
    return "pending";
  } else if (status instanceof Verified) {
    return "verified";
  } else if (status instanceof NotVerified) {
    return "not-verified";
  } else if (status instanceof Archived) {
    return "archived";
  } else if (status instanceof Outdated) {
    return "outdated";
  } else if (status instanceof Processing) {
    return "processing";
  } else {
    return "failed";
  }
}

export function encode(data_source) {
  return $json.object(
    toList([
      ["id", $json.string(data_source.id)],
      ["status", $json.string(status_to_string(data_source.status))],
      ["display", encode_display(data_source.display)],
      ["kind", $connector.encode(data_source.kind)],
      ["authors", $json.array(data_source.authors, $user_id.encode)],
      ["owner", $json.nullable(data_source.owner, $user_id.encode)],
      ["document_id", $json.string(data_source.document_id)],
      ["blob_link", $json.string(data_source.blob_link)],
      ["content_link", $json.string(data_source.content_link)],
      ["hash", $json.nullable(data_source.hash, $json.string)],
      ["version", $json.int(data_source.version)],
      ["tags", $json.array(data_source.tags, $json.string)],
      ["org_id", $json.string(data_source.org_id)],
      [
        "expiration_date",
        $json.nullable(
          data_source.expiration_date,
          (date) => {
            return $json.string(
              $timestamp.to_rfc3339(date, $calendar.utc_offset),
            );
          },
        ),
      ],
    ]),
  );
}

export function encode_status_stats(status_stats) {
  return $json.object(
    toList([
      [status_to_string(new Pending()), $json.int(status_stats.pending)],
      [status_to_string(new Outdated()), $json.int(status_stats.outdated)],
      [status_to_string(new Verified()), $json.int(status_stats.verified)],
      [
        status_to_string(new NotVerified()),
        $json.int(status_stats.not_verified),
      ],
    ]),
  );
}

export function decode_status_stats() {
  return $decode.field(
    status_to_string(new Pending()),
    $decode.int,
    (pending) => {
      return $decode.field(
        status_to_string(new Outdated()),
        $decode.int,
        (outdated) => {
          return $decode.field(
            status_to_string(new Verified()),
            $decode.int,
            (verified) => {
              return $decode.field(
                status_to_string(new NotVerified()),
                $decode.int,
                (not_verified) => {
                  return $decode.success(
                    new StatusStats(verified, pending, not_verified, outdated),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function status_to_display(status) {
  if (status instanceof Pending) {
    return "Pending";
  } else if (status instanceof Verified) {
    return "Verified";
  } else if (status instanceof NotVerified) {
    return "Not Verified";
  } else if (status instanceof Archived) {
    return "Archived";
  } else if (status instanceof Outdated) {
    return "Outdated";
  } else if (status instanceof Processing) {
    return "Processing";
  } else {
    return "Failed";
  }
}

function display_decoder() {
  return $decode.field(
    "name",
    $decode.string,
    (name) => {
      return $decrypt.optional_field(
        "language",
        $decode.string,
        (language) => {
          return $decode.field(
            "mime_type",
            $mime_types.decoder(),
            (mime_type) => {
              return $decrypt.optional_field(
                "origin",
                $decode.string,
                (origin) => {
                  return $decrypt.optional_field(
                    "qna",
                    $decode.field(
                      "question",
                      $decode.string,
                      (question) => {
                        return $decode.field(
                          "answer",
                          $decode.string,
                          (answer) => {
                            return $decode.success(new Qna(question, answer));
                          },
                        );
                      },
                    ),
                    (qna) => {
                      return $decode.optional_field(
                        "breadcrumbs",
                        toList([]),
                        $decode.list($decode.string),
                        (breadcrumbs) => {
                          return $decode.success(
                            new Display(
                              name,
                              language,
                              mime_type,
                              origin,
                              qna,
                              breadcrumbs,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function status_decoder() {
  return $decode.then$(
    $decode.string,
    (status) => {
      if (status === "archived") {
        return $decode.success(new Archived());
      } else if (status === "not-verified") {
        return $decode.success(new NotVerified());
      } else if (status === "pending") {
        return $decode.success(new Pending());
      } else if (status === "verified") {
        return $decode.success(new Verified());
      } else if (status === "outdated") {
        return $decode.success(new Outdated());
      } else if (status === "processing") {
        return $decode.success(new Processing());
      } else if (status === "failed") {
        return $decode.success(new Failed());
      } else {
        return $decode.failure(new Archived(), "Status");
      }
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decrypt.uuid(),
    (id) => {
      return $decode.field(
        "status",
        status_decoder(),
        (status) => {
          return $decode.field(
            "display",
            $decrypt.json(display_decoder()),
            (display) => {
              return $decode.field(
                "kind",
                $connector.decoder(),
                (kind) => {
                  return $decode.field(
                    "authors",
                    (() => {
                      let _pipe = $decode.list(
                        $decode.optional($user_id.decoder()),
                      );
                      let _pipe$1 = $decode.map(_pipe, $option.all);
                      let _pipe$2 = $decode.optional(_pipe$1);
                      let _pipe$3 = $decode.map(_pipe$2, $option.flatten);
                      return $decode.map(
                        _pipe$3,
                        (_capture) => {
                          return $option.unwrap(_capture, toList([]));
                        },
                      );
                    })(),
                    (authors) => {
                      return $decode.field(
                        "owner",
                        $decode.optional($user_id.decoder()),
                        (owner) => {
                          return $decode.field(
                            "document_id",
                            $decode.string,
                            (document_id) => {
                              return $decode.field(
                                "blob_link",
                                $decode.string,
                                (blob_link) => {
                                  return $decode.field(
                                    "content_link",
                                    $decode.string,
                                    (content_link) => {
                                      return $decode.field(
                                        "hash",
                                        $decode.optional($decode.string),
                                        (hash) => {
                                          return $decode.field(
                                            "version",
                                            $decode.int,
                                            (version) => {
                                              return $decode.field(
                                                "tags",
                                                (() => {
                                                  let _pipe = $decode.optional(
                                                    $decode.list($decode.string),
                                                  );
                                                  return $decode.map(
                                                    _pipe,
                                                    (_capture) => {
                                                      return $option.unwrap(
                                                        _capture,
                                                        toList([]),
                                                      );
                                                    },
                                                  );
                                                })(),
                                                (tags) => {
                                                  return $decode.field(
                                                    "org_id",
                                                    $decode.string,
                                                    (org_id) => {
                                                      let expiration_date = $decode.optional(
                                                        $decrypt.timestamp(),
                                                      );
                                                      return $decode.field(
                                                        "expiration_date",
                                                        expiration_date,
                                                        (expiration_date) => {
                                                          return $decode.success(
                                                            new DataSource(
                                                              id,
                                                              status,
                                                              display,
                                                              kind,
                                                              authors,
                                                              owner,
                                                              document_id,
                                                              blob_link,
                                                              content_link,
                                                              hash,
                                                              version,
                                                              tags,
                                                              org_id,
                                                              expiration_date,
                                                            ),
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_content_library_stats(stats) {
  let _pipe = toList([
    [new Verified(), stats.verified],
    [new Pending(), stats.pending],
    [new NotVerified(), stats.not_verified],
    [new Outdated(), stats.outdated],
  ]);
  let _pipe$1 = $list.map(
    _pipe,
    (_capture) => { return $pair.map_first(_capture, status_to_string); },
  );
  let _pipe$2 = $list.map(
    _pipe$1,
    (_capture) => { return $pair.map_second(_capture, $json.int); },
  );
  return $json.object(_pipe$2);
}

function decode_optional_field(field, default$, decoder, next) {
  let decoder$1 = $decode.optional(decoder);
  return $decode.then$(
    $decode.optionally_at(toList([field]), new None(), decoder$1),
    (content) => {
      if (content instanceof Some) {
        let content$1 = content[0];
        return next(content$1);
      } else {
        return next(default$);
      }
    },
  );
}

export function content_library_stats_decoder() {
  return decode_optional_field(
    status_to_string(new Verified()),
    0,
    $decode.int,
    (a) => {
      return decode_optional_field(
        status_to_string(new Pending()),
        0,
        $decode.int,
        (b) => {
          return decode_optional_field(
            status_to_string(new NotVerified()),
            0,
            $decode.int,
            (c) => {
              return decode_optional_field(
                status_to_string(new Outdated()),
                0,
                $decode.int,
                (d) => { return $decode.success(new StatusStats(a, b, c, d)); },
              );
            },
          );
        },
      );
    },
  );
}

export function init_source_filters() {
  return new SourceFilters(toList([]), toList([]), toList([]));
}

export function sort_filters(filters) {
  return new SourceFilters(
    $list.sort(filters.included_tags, $tag.compare),
    $list.sort(filters.excluded_tags, $tag.compare),
    $list.sort(filters.excluded_kinds, $connector.compare),
  );
}

export function source_filters_encode(source_filters) {
  let $ = sort_filters(source_filters);
  let included_tags = $.included_tags;
  let excluded_tags = $.excluded_tags;
  let excluded_kinds = $.excluded_kinds;
  return $json.object(
    toList([
      ["included_tags", $json.array(included_tags, $tag.encode)],
      ["excluded_tags", $json.array(excluded_tags, $tag.encode)],
      ["excluded_kinds", $json.array(excluded_kinds, $connector.encode)],
    ]),
  );
}

export function source_filters_decoder() {
  return $decode.field(
    "included_tags",
    $decode.list($tag.decoder()),
    (included_tags) => {
      return $decode.field(
        "excluded_tags",
        $decode.list($tag.decoder()),
        (excluded_tags) => {
          return $decode.field(
            "excluded_kinds",
            $decode.list($connector.decoder()),
            (excluded_kinds) => {
              let _pipe = new SourceFilters(
                included_tags,
                excluded_tags,
                excluded_kinds,
              );
              let _pipe$1 = sort_filters(_pipe);
              return $decode.success(_pipe$1);
            },
          );
        },
      );
    },
  );
}

export function filters_are_empty(filters) {
  return isEqual(filters, new SourceFilters(toList([]), toList([]), toList([])));
}

export function decrease_status_stats(stats, data_source) {
  let $ = data_source.status;
  if ($ instanceof Pending) {
    return new StatusStats(
      stats.verified,
      stats.pending - 1,
      stats.not_verified,
      stats.outdated,
    );
  } else if ($ instanceof Verified) {
    return new StatusStats(
      stats.verified - 1,
      stats.pending,
      stats.not_verified,
      stats.outdated,
    );
  } else if ($ instanceof NotVerified) {
    return new StatusStats(
      stats.verified,
      stats.pending,
      stats.not_verified - 1,
      stats.outdated,
    );
  } else if ($ instanceof Outdated) {
    return new StatusStats(
      stats.verified,
      stats.pending,
      stats.not_verified,
      stats.outdated - 1,
    );
  } else {
    return stats;
  }
}

export function source_url(source) {
  let _pipe = source.display.origin;
  return $option.unwrap(_pipe, source.display.name);
}
